import { apiRequest } from '@/services';
import * as env from '@/config/env';

const responseCache = new Map();
const pendingRequests = new Map();

const getCacheKey = (companyId, userId) => `${companyId || ''}:${userId || ''}`;

export const getProjectFilters = (companyId, userId, force = false) => {
    const cacheKey = getCacheKey(companyId, userId);

    if (!force && responseCache.has(cacheKey)) {
        return Promise.resolve(responseCache.get(cacheKey));
    }

    if (pendingRequests.has(cacheKey)) {
        return pendingRequests.get(cacheKey);
    }

    const request = apiRequest('get', `${env.PROJECT_GLOBAL_FILTER}/${userId}`)
        .then((result) => {
            responseCache.set(cacheKey, result);
            return result;
        })
        .finally(() => pendingRequests.delete(cacheKey));

    pendingRequests.set(cacheKey, request);
    return request;
};

export const invalidateProjectFilters = (companyId, userId) => {
    responseCache.delete(getCacheKey(companyId, userId));
};
